import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateApproveListEmployer = {
  approveListEmployer: { data: null, loading: false, error: null },
};

export const approveListEmployer = createAsyncThunk('user/approveListEmployer', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/employers/verification`,
      { employers: data.employers, is_verified: true, verification_status: 'approved' },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerApproveListEmployer = {
  [approveListEmployer.pending]: (state) => {
    state.approveListEmployer.loading = true;
    state.approveListEmployer.error = null;
  },
  [approveListEmployer.fulfilled]: (state, action) => {
    state.approveListEmployer.loading = false;
    state.approveListEmployer.data = true;
    state.approveListEmployer.error = null;
  },
  [approveListEmployer.rejected]: (state, action) => {
    state.approveListEmployer.loading = false;
    state.approveListEmployer.error = action.payload;
  },
};
